<template>
  <div class="head" :class="[onscroll && !headType ? 'headBg' : '', headType]">
    <div class="content">
    <router-link class="logo" :to="{name: 'Home'}"></router-link>
    <div class="nav-list" :class="{slideIn: isShow, slideOut: !isShow}">
      <div class="meu-close" @click="showMeu"></div>
      <ul class="nav-1">
        <li @mouseleave="hiddenSubMenu" class="nav-1-item" v-for="(item, index) of navList" :key="index" :class="{selected: pathName === item.pathName || item.isActive}">
          <span v-if="item.title === '测算系统'">
            <a class="a-link" :href="calUrl" target="_blank">测算系统</a>
          </span>
          <span v-else @mouseover="overMenu(item, index)" @click="showSubMenu(item.pathName, index)">{{item.title}}</span>
          <div class="haveSub" v-if="item.list && item.list.length>0"></div>
          <div class="nav-2" v-if="subMeun === index">
            <ul>
              <li v-for="(inav, i) in item.list" :key="i">
                <span :class="{activeSubMenu: pathName === inav.pathName}" @click="selectSubMenu(inav.pathName, index)">{{inav.title}}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <router-link :to="{name: 'shoppingCart'}" class="cart-link a-link">
        <i class="el-icon-shopping-cart-full"></i> <span class="a-dot" v-if="num">{{num}}</span>
      </router-link>
    </div>
    </div>
    <!--手机端右侧按钮-->
    <div class="nav-r meu-all" @click="showMeu">
      <div class="icon">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="mask" v-if="isShow" @click="showMeu"></div>
</div>
</template>

<script>
export default {
  props: {
    headType: String
  },
  data () {
    return {
      isActive: false,
      subMeun: -1,
      isNav2: -1,
      calUrl: process.env.VUE_APP_CAL_URL,
      navList: [{
        title: '服务与解决方案',
        pathName: '',
        isActive: false,
        list: [
          {
            title: '猪小智模式',
            pathName: 'piggery'
          },
          {
            title: 'EPC模式',
            pathName: 'EPC'
          },
          // {
          //   title: '金融模式',
          //   pathName: 'finance'
          // },
          {
            title: '农信云',
            pathName: 'cloud'
          },
          {
            title: '产品中心',
            pathName: 'productCenter'
          },
          {
            title: '软件中心',
            pathName: 'softwareCenter'
          }
        ]
      },
      {
        title: '核心竞争力',
        pathName: 'coreCompetence'
      },
      {
        title: '商业案例',
        pathName: 'caseExample'
      },
      {
        title: '资讯中心',
        pathName: '',
        isActive: false,
        list: [{
          title: '企业动态',
          pathName: 'campanyNews'
        },
        {
          title: '行业动态',
          pathName: 'pigNews'
        }]
      },
      {
        title: '测算系统',
        pathName: 'calSystem'
      },
      {
        title: '关于农芯',
        pathName: '',
        isActive: false,
        list: [{
          title: '公司介绍',
          pathName: 'companyIntro'
        },
        {
          title: '加入我们',
          pathName: 'joinUs'
        },
        {
          title: '服务专家',
          pathName: 'piggerySpecialist'
        }]
      },
      {
        title: '咨询',
        pathName: 'consult'
      }
      ],
      isShow: false,
      onscroll: false,
      // hrefLink: 'http://console.p.nxinyun.com'
      hrefLink: 'http://console.nxinyun.com', // todo
      num: 0
    }
  },
  computed: {
    pathName () {
    //   this.isShow = false
      const name = this.$route.name
      this.navList.map((o) => {
        if (o.list && o.list.length > 0) {
          for (const sub of o.list) {
            if (sub.pathName === name) {
              this.isActive = true
            }
          }
          o.isActive = this.isActive
          this.isActive = false
        }
      })
      document.documentElement.scrollTop = 0
      return name
    },
    cartNum () {
      return this.$store.state.cartNum
    }
  },
  mounted () {
    this.getCartNum()
    window.onscroll = () => {
      const a = document.documentElement.scrollTop || document.body.scrollTop
      if (a > 0) {
        this.onscroll = true
      } else {
        this.onscroll = false
      }
    }
  },
  watch: {
    cartNum () {
      this.getCartNum()
    }
  },
  methods: {
    getCartNum () { // 获取购物车商品数量
      let data = localStorage.getItem('prdt')
      data = data ? JSON.parse(data) : []
      this.num = data.length > 99 ? '99+' : data.length
    },
    /* 选择子菜单 */
    selectSubMenu (pathName, index) {
      this.$router.push({
        name: pathName
      })
      this.isShow = false
    },
    overMenu (item, index) {
      this.subMeun = -1
      if (item.list && item.list.length) {
        this.subMeun = index
      }
    },
    /* 选择主菜单 */
    showSubMenu (pathName, index) {
      if (pathName) {
        this.$router.push({
          name: pathName
        })
        this.isShow = false
      } else {
        this.subMeun = index
      }
    },
    hiddenSubMenu () {
      this.subMeun = -1
    },
    /* 选择headNav */
    selectNavItem (index) {
      this.isNav2 = index
    },
    showMeu () {
      this.isShow = !this.isShow
    }
  }
}
</script>
